/**
 * Tombol WhatsApp mengambang untuk consultations.
 *
 * Dipasang di dalam Shell, jadi otomatis muncul di semua halaman aplikasi --
 * dashboard, Photo Studio, Content Studio, History, Profile, Admin -- tanpa
 * perlu ditambahkan satu per satu di tiap file.
 *
 * Format nomor: internasional tanpa "+" dan tanpa spasi (62 + nomor lokal).
 * wa.me menolak format lain, jadi angka di bawah jangan diubah formatnya.
 */

import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WA_NUMBER = "6281390339641";

function waLink(message) {
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
}

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);

  // Muncul sedikit menunda supaya tidak ikut Reply layout pas halaman dibuka.
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const topics = [
    {
      label: "Cara pakai tools",
      message:
        "Halo, saya butuh penjelasan cara pakai AI Photo Studio / AI Konten Studio.",
    },
    {
      label: "Kendala generate",
      message:
        "Halo, saya lagi Kendala saat generate di AI Photo Studio. Mohon bantuannya.",
    },
    {
      label: "Pembelian & aktivasi",
      message:
        "Halo, saya mau tanya soal pembelian akses dan kode aktivasi.",
    },
  ];

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2.5 print:hidden">
      {open && (
        <div className="w-60 overflow-hidden border border-zinc-200 bg-[#FBFBF9] shadow-lg">
          <div className="flex items-center justify-between border-b border-zinc-200 bg-[#25D366] px-3 py-2.5">
            <div className="min-w-0">
              <p className="text-[12px] font-semibold leading-tight text-white">
                Butuh bantuan?
              </p>
              <p className="text-[11px] leading-tight text-white/90">
                Balas lewat WhatsApp
              </p>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Tutup"
              className="shrink-0 text-white/90 hover:text-white"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="flex flex-col">
            {topics.map((t) => (
              <a
                key={t.label}
                href={waLink(t.message)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`wa-topic-${t.label.replace(/\s+/g, "-").toLowerCase()}`}
                className="border-b border-zinc-100 px-3 py-2.5 text-[12px] text-zinc-800 last:border-b-0 hover:bg-zinc-100"
              >
                {t.label}
              </a>
            ))}
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Hubungi lewat WhatsApp"
        data-testid="wa-floating-button"
        className="flex h-13 w-13 items-center justify-center rounded-full bg-[#25D366] p-3.5 text-white shadow-lg hover:bg-[#1eb455]"
      >
        {open ? (
          <X className="h-5 w-5" />
        ) : (
          <MessageCircle className="h-5 w-5" />
        )}
      </button>
    </div>
  );
}